module.exports = __webpack_public_path__ + "static/media/ee.9e932a62.svg";